module.exports = __webpack_public_path__ + "img/2tgvi-e80-1050.prt.510ae14f.jpg";